
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import Swal from 'sweetalert2'

import history from '../../Helpers/History'
import useTranslation from '../../Hooks/UseTranslation'

import SessionActions from '../../Redux/Actions/SessionActions'

import TopLoader from '../../Components/TopLoader/TopLoader'

import AuthLayout from '../../Layouts/AuthLayout/AuthLayout'

import '../LoginPage/LoginPage.scss'
import './ForgotPage.scss'

const ForgotPage = (props: any) => {

    const { t } = useTranslation()

    const requestRecoveryStatus = useSelector((state: any) => state.SessionReducer.requestRecoveryStatus)
    const dispatch = useDispatch()

    const [ email, setEmail ] = useState('')

    if (requestRecoveryStatus === 'requested') {

        Swal.fire({
            title: t('FORGOT_PASSWORD:RequestSentTitle'),
            text: t('FORGOT_PASSWORD:RequestSentContent'),
            icon: 'success',
            confirmButtonText: t('FORGOT_PASSWORD:RequestSentCloseButton'),
            width: '500px',
            onClose: () => history.push('/login')
        })
    }

    const requestRecovery = () => {

        dispatch(SessionActions.requestRecoveryAction(email))
    }

    return (
        <AuthLayout className="pl4-auth-layout--login pl4-auth-layout--forgot">
            <main className="pl4-login-page pl4-forgot-page">
                <section className="pl4-login-showcase pl4-forgot-showcase" aria-hidden="true">
                    <div className="pl4-login-showcase__brand">
                        <img className="pl4-login-showcase__brand-icon" src="/svg-icons/logo-icon.svg" alt="" aria-hidden="true" />
                        <img className="pl4-login-showcase__brand-logo" src="/svg-icons/logo.svg" alt="PL4NNER" />
                    </div>

                    <div className="pl4-forgot-showcase__visual">
                        <div className="pl4-forgot-showcase__intro">
                            <span><i className="fas fa-shield-alt" /></span>
                            <div>
                                <small>{t('FORGOT_PASSWORD:Eyebrow')}</small>
                                <strong>{t('FORGOT_PASSWORD:ShowcaseTitle')}</strong>
                            </div>
                        </div>

                        <div className="pl4-forgot-showcase__flow">
                            <div className="pl4-forgot-showcase__step is-active">
                                <span><i className="far fa-envelope" /></span>
                                <i />
                            </div>
                            <div className="pl4-forgot-showcase__step">
                                <span><i className="fas fa-link" /></span>
                                <i />
                            </div>
                            <div className="pl4-forgot-showcase__step">
                                <span><i className="fas fa-key" /></span>
                            </div>
                        </div>

                        <div className="pl4-forgot-showcase__mail">
                            <span><i className="far fa-envelope-open" /></span>
                            <div>
                                <i />
                                <i />
                                <i />
                            </div>
                            <strong><i className="fas fa-check" /></strong>
                        </div>
                    </div>
                </section>

                <section className="pl4-login-panel pl4-forgot-panel">
                    <div className="pl4-login-form pl4-forgot-form">
                        <img className="pl4-login-form__logo" src="/images/logo.svg" alt="PL4NNER" />

                        <div className="pl4-forgot-heading-icon" aria-hidden="true">
                            <i className="fas fa-unlock-alt" />
                        </div>

                        <div className="pl4-login-form__heading">
                            <span>{t('FORGOT_PASSWORD:Eyebrow')}</span>
                            <h1>{t('FORGOT_PASSWORD:ForgotPassword-title')}</h1>
                            <p>{t('FORGOT_PASSWORD:Subtitle')}</p>
                        </div>

                        <form
                            noValidate
                            onSubmit={(event) => {
                                event.preventDefault()
                                requestRecovery()
                            }}
                        >
                            <div className="pl4-login-field">
                                <label htmlFor="forgot-email">{t('FORGOT_PASSWORD:EmailLabel')}</label>
                                <div className="pl4-login-input">
                                    <i className="far fa-envelope" aria-hidden="true" />
                                    <input
                                        autoComplete="email"
                                        autoFocus
                                        id="forgot-email"
                                        placeholder={t('FORGOT_PASSWORD:Placeholder-Email')}
                                        type="email"
                                        value={email}
                                        onChange={(event) => setEmail(event.target.value)}
                                    />
                                </div>
                            </div>

                            <p className="pl4-forgot-help">
                                <i className="fas fa-info-circle" aria-hidden="true" />
                                {t('FORGOT_PASSWORD:HelpText')}
                            </p>

                            <button
                                className="pl4-btn pl4-btn-primary pl4-login-submit"
                                disabled={requestRecoveryStatus === 'requesting'}
                                type="submit"
                            >
                                {requestRecoveryStatus === 'requesting' && (
                                    <i className="fas fa-circle-notch fa-spin" aria-hidden="true" />
                                )}
                                {t('FORGOT_PASSWORD:SendButton')}
                            </button>

                            <Link className="pl4-forgot-back" to="/login">
                                <i className="fas fa-arrow-left" aria-hidden="true" />
                                {t('FORGOT_PASSWORD:BackToLogin')}
                            </Link>
                        </form>
                    </div>
                </section>
            </main>
            <TopLoader show={requestRecoveryStatus === 'requesting'} />
        </AuthLayout>
    )
}

export default ForgotPage
